module.exports = __webpack_public_path__ + "static/media/Impreza-GV-WRX-STi.acb6e8df.jpg";